import gql from 'graphql-tag';

export const LastMeetingDateQuery = gql`
  query lastMeetingDate($where: LastMeetingDateWhereInput) {
    lastMeetingDate(where: $where) {
      id
      time_from
    }
  }
`;
